/**
 * Bộ biểu tượng SVG nét (outline) một màu, kế thừa màu chữ (`currentColor`) — đúng
 * quy ước "Biểu tượng" của mẫu giao diện "Thông tin nguồn". Biểu tượng chỉ để
 * trang trí: luôn đi kèm nhãn chữ nên đặt `aria-hidden`.
 */
import type { ReactNode } from 'react';

export type TenBieuTuong =
  | 'tong-quan'
  | 'loa'
  | 'noi-dung'
  | 'lich'
  | 'phat-song'
  | 'man-hinh'
  | 'bao-cao'
  | 'tich-hop'
  | 'danh-muc'
  | 'quan-tri'
  | 'menu'
  | 'chuong'
  | 'nguoi-dung'
  | 'mui-ten-xuong'
  | 'ket-noi'
  | 'mat-ket-noi'
  | 'tam-dung'
  | 'mat'
  | 'mat-an'
  | 'huong-dan'
  | 'thong-bao'
  | 'dang-xuat'
  | 'tim-kiem'
  | 'dieu-khien'
  | 'phat'
  | 'lam-moi';

const NET: Record<TenBieuTuong, ReactNode> = {
  'tim-kiem': (
    <>
      <circle cx="11" cy="11" r="6" />
      <path d="M20 20l-4.5-4.5" />
    </>
  ),
  'dieu-khien': (
    <>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M9 8v8M15 8v8M7 11h4M13 14h4" />
    </>
  ),
  phat: <path d="M8 5v14l11-7z" />,
  'lam-moi': (
    <>
      <path d="M20 12a8 8 0 1 1-2.34-5.66" />
      <path d="M20 4v5h-5" />
    </>
  ),
  'tong-quan': (
    <>
      <rect x="4" y="4" width="7" height="7" rx="1.5" />
      <rect x="13" y="4" width="7" height="7" rx="1.5" />
      <rect x="4" y="13" width="7" height="7" rx="1.5" />
      <rect x="13" y="13" width="7" height="7" rx="1.5" />
    </>
  ),
  loa: (
    <>
      <path d="M4 10v4h4l5 4V6L8 10H4z" />
      <path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12" />
    </>
  ),
  'noi-dung': (
    <>
      <path d="M4 20h4l10.5-10.5a2.1 2.1 0 0 0-3-3L5 17v3z" />
      <path d="M14 8l3 3" />
    </>
  ),
  lich: (
    <>
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M4 10h16M9 3v4M15 3v4" />
    </>
  ),
  'phat-song': (
    <>
      <circle cx="12" cy="12" r="2" />
      <path d="M8.5 15.5a5 5 0 0 1 0-7M15.5 8.5a5 5 0 0 1 0 7M5.6 18.4a9 9 0 0 1 0-12.8M18.4 5.6a9 9 0 0 1 0 12.8" />
    </>
  ),
  'man-hinh': (
    <>
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8M12 16v4" />
    </>
  ),
  'bao-cao': (
    <>
      <path d="M4 20V4M4 20h16" />
      <path d="M8 16v-4M12 16V8M16 16v-6" />
    </>
  ),
  'tich-hop': (
    <>
      <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
      <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
    </>
  ),
  'danh-muc': (
    <>
      <path d="M9 6h11M9 12h11M9 18h11" />
      <circle cx="5" cy="6" r="1" />
      <circle cx="5" cy="12" r="1" />
      <circle cx="5" cy="18" r="1" />
    </>
  ),
  'quan-tri': (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21M5.6 5.6l1.8 1.8M16.6 16.6l1.8 1.8M5.6 18.4l1.8-1.8M16.6 7.4l1.8-1.8" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h12M4 17h16" />,
  chuong: <path d="M6 16v-5a6 6 0 0 1 12 0v5l2 2H4l2-2zM10 20a2 2 0 0 0 4 0" />,
  'nguoi-dung': (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
    </>
  ),
  'mui-ten-xuong': <path d="M6 9l6 6 6-6" />,
  'ket-noi': (
    <>
      <path d="M5 12.5a10 10 0 0 1 14 0M8 15.5a5.5 5.5 0 0 1 8 0" />
      <circle cx="12" cy="19" r="1" />
    </>
  ),
  'mat-ket-noi': (
    <>
      <path d="M8 15.5a5.5 5.5 0 0 1 8 0M5 12.5a10 10 0 0 1 3-2" />
      <path d="M3 3l18 18" />
      <circle cx="12" cy="19" r="1" />
    </>
  ),
  'tam-dung': (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M10 9v6M14 9v6" />
    </>
  ),
  mat: (
    <>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  'huong-dan': (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6M12 17h.01" />
    </>
  ),
  'thong-bao': <path d="M6 3h12l-2 9 2 9H6z" />,
  'dang-xuat': (
    <>
      <path d="M15 4h4v16h-4" />
      <path d="M10 8l-4 4 4 4M6 12h10" />
    </>
  ),
  'mat-an': (
    <>
      <path d="M3 3l18 18" />
      <path d="M10.6 5.1A9.8 9.8 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3 3.8M6.2 6.2A17 17 0 0 0 2 12s3.5 7 10 7a9.7 9.7 0 0 0 5-1.4" />
      <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    </>
  ),
};

export interface BieuTuongProps {
  ten: TenBieuTuong;
  /** Cạnh biểu tượng, px. Menu 16, topbar 22, thẻ số liệu 32. */
  co?: number;
  className?: string;
}

export function BieuTuong({ ten, co = 16, className }: BieuTuongProps): ReactNode {
  return (
    <svg
      className={className}
      width={co}
      height={co}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {NET[ten]}
    </svg>
  );
}
